import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useTypedParams } from '@sorare/routing';

import { usePaginatedQuery } from '@sorare/core/src/hooks/graphql/usePaginatedQuery';

import { UserFixtureResults } from '@sorare/gameplay/src/components/profile/UserFixtureResults';
import { getFixtureQueryVariables } from '@sorare/gameplay/src/lib/so5';

import type {
  FootballProHistoryFixturePageQuery,
  FootballProHistoryFixturePageQueryVariables,
} from './__generated__/page.graphql';
import type { PageParams } from './__generated__/routeParams';

const PRO_HISTORY_FIXTURE_PAGE_QUERY = gql`
  query FootballProHistoryFixturePageQuery(
    $user: String!
    $slug: String
    $type: So5State
    $cursor: String
  ) {
    so5 {
      so5Fixture(slug: $slug, type: $type) {
        slug
        ...UserFixtureResults_so5Fixture
      }
    }
  }
  ${UserFixtureResults.fragments.so5Fixture}
` as TypedDocumentNode<
  FootballProHistoryFixturePageQuery,
  FootballProHistoryFixturePageQueryVariables
>;

const HistoryFixturePage = () => {
  const { slug, fixture } = useTypedParams<PageParams>();
  const { data, loading, loadMore } = usePaginatedQuery(
    PRO_HISTORY_FIXTURE_PAGE_QUERY,
    {
      variables: {
        user: slug,
        ...getFixtureQueryVariables(fixture),
      },
      connection: 'So5LeaderboardContenderConnection',
    }
  );

  const { so5Fixture } = data?.so5 || {};

  return (
    <UserFixtureResults
      so5Fixture={so5Fixture}
      loadMoreUserResults={loadMore}
      moreResultsLoading={loading}
    />
  );
};

export default HistoryFixturePage;
